import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GermplasmService } from '../shared/germplasm/service/germplasm.service';
import { of } from 'rxjs';
import { GermplasmSearchRequest } from '../entities/germplasm/germplasm-search-request.model';
import { map, switchMap } from 'rxjs/operators';

export const germplasmGidResolver: ResolveFn<number | null> = (route) => {
    const germplasmService = inject(GermplasmService);
    const gid = route.paramMap.get('gid');
    const germplasmUUID = route.queryParamMap.get('germplasmUUID');

    if (germplasmUUID) {

        console.warn(`[germplasmGidResolver] guuid request param is available, resolving from germplasmUUID: ${germplasmUUID}`);

        const request = new GermplasmSearchRequest();
        request.germplasmUUID = germplasmUUID;

        return inject(GermplasmService).search(request).pipe(
            switchMap(searchRequestId =>
                germplasmService.getAllGermplasm(searchRequestId)
            ),
            map(germplasm => germplasm?.[0]?.gid ?? null)
        );
    }

    console.warn(`[germplasmGidResolver] germplasmUUID request param is NOT available, returning gid from path: ${gid}`);

    return of(gid ? Number(gid) : null);
};
